/** General factsheet / CDN image upload limit (matches server UPLOAD_MAX_FILE_BYTES). */
export const UPLOAD_MAX_FILE_BYTES = 5 * 1024 * 1024;

export const UPLOAD_MAX_FILE_MB = UPLOAD_MAX_FILE_BYTES / (1024 * 1024);

export function isUploadWithinLimit(file: { size: number } | null | undefined): boolean {
  if (!file) return false;
  return file.size <= UPLOAD_MAX_FILE_BYTES;
}

export function uploadLimitExceededMessage(fileSize?: number): string {
  const mb = UPLOAD_MAX_FILE_MB;
  if (fileSize != null && Number.isFinite(fileSize)) {
    const actual = (fileSize / (1024 * 1024)).toFixed(1);
    return `File is too large (${actual} MB). Maximum upload size is ${mb} MB.`;
  }
  return `File is too large. Maximum upload size is ${mb} MB.`;
}
